exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link[data-v-ab262b6a]{display:block;margin-bottom:10px}", ""]);

